import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Divider,
    Typography,
    Box
} from '@material-ui/core';
import moment from 'moment';

const InfoRow = ({ label, value }) => (
    <Box display="flex" mb={2}>
        <Typography variant="subtitle2" style={{ minWidth: 130, fontWeight: 500 }}>
            {label}:
        </Typography>
        <Typography variant="body1" color="textSecondary">
            {value || '—'}
        </Typography>
    </Box>
);

const CMLoggingViewModal = ({ open, onClose, record }) => {

    if (!record) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Log Details</DialogTitle>
            <Divider />
            <DialogContent>
                <Box mt={1}>
                    <InfoRow
                        label="Date"
                        value={moment.utc(record.date).local().format("YYYY-MM-DD HH:mm:ss")}
                    />
                    <InfoRow label="Tenant" value={record.tenant?.name} />
                    <InfoRow label="Tenant Group" value={record.tenant?.tenant_group?.name} />
                    <InfoRow label="Type" value={record.type} />
                    <InfoRow label="Message" value={record.message} />
                    <InfoRow label="System Id" value={record.system_id} />
                    <InfoRow label="Thirdparty Id" value={record.thirdparty_id} />

                    {record.thirdparty_id && (
                        <Box mt={3}>
                            <Typography variant="subtitle1" gutterBottom>
                                JSON Payload
                            </Typography>
                            {record.payload ? (() => {
                                try {
                                    const parsedPayload = JSON.parse(record.payload);
                                    return (
                                        <Box
                                            component="pre"
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                padding: 16,
                                                borderRadius: 4,
                                                maxHeight: 300,
                                                overflow: 'auto',
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {JSON.stringify(parsedPayload, null, 2)}
                                        </Box>
                                    );
                                } catch (e) {
                                    return (
                                        <Typography variant="body2" color="error">
                                            Invalid JSON format
                                        </Typography>
                                    );
                                }
                            })() : (
                                <Typography variant="body2">No payload data available.</Typography>
                            )}

                        </Box>
                    )}
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CMLoggingViewModal;
